import type { RequestResponse } from '@/types/publicType'
import type {
  callPricesInterface,
  matchPoolDetailInterface,
  callHangInterface
} from '@/types/apiType/callType'

/**
 * 拨号
 * @param {number} targetUid 目标ID
 * @param {0|1} match 0正常拨号，1匹配拨号
 * @param {1|4|5|6|8} callType  网页端：1首页，4直播间，5私聊，6个人弹窗，8充值复拨 ；APP：1热门页，2发现页，3关注页，4直播间页，5私聊，6个人主页，7个人小窗，8 h5
 * @param {boolean} useFree 是否使用电话卡
 */
export function apiCallDial(params: {
  targetUid: number
  match: 0 | 1
  callType: 1 | 4 | 5 | 6 | 8
  useFree: boolean
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/dial',
    method: 'GET',
    params,
    loading: true,
    isCloseTost: true
  })
}
/**
 * 接听-允许
 * @param {number} targetUid 接收消息的用户
 */
export function apiCallEnable(params: {
  targetUid: number
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/enable',
    method: 'GET',
    params
  })
}
/**
 * 拒绝接听或取消拨号
 * @param {number} calledUid 目标ID
 * @param {0|1|2} refuseType 2 匹配拒绝 1 拒绝接听 0 超时
 */
export function apiCallCancel(params: {
  calledUid: number
  refuseType: 0 | 1 | 2
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/cancel',
    method: 'GET',
    params
  })
}
/**
 * 获取被呼叫人的通话价格
 * @param {number} priceUid // 被呼叫人
 * @param {1|2} type // 1：拨打，2：匹配
 */
export function apiGetCallPrices(data: {
  priceUid: number
  type: 1 | 2
}): Promise<RequestResponse<callPricesInterface>> {
  return getFetchData({
    url: '/h5/c/prices',
    method: 'POST',
    data
  })
}
/**
 * 通话结束-结束扣费
 * @param {number | string} roomId 房间ID
 */
export function apiCallHang(params: {
  roomId: number | string
}): Promise<RequestResponse<callHangInterface>> {
  return getFetchData({
    url: '/h5/c/hang',
    method: 'GET',
    params
  })
}
/**
 * 匹配-加入
 */
export function apiCallMatch(): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/m',
    method: 'GET',
    params: {
      appVersion: 1
    },
    loading: true
  })
}
/**
 * 匹配-取消
 */
export function apiCallCancelMatch(): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/cm',
    method: 'GET'
  })
}

/**
 * 匹配检测
 */
export function apiMatchPoolDetail(): Promise<
  RequestResponse<matchPoolDetailInterface>
> {
  return getFetchData({
    url: '/h5/c/matchPoolDetail',
    method: 'GET'
  })
}
